import React from 'react';
import classNames from 'classnames';

import { capitalize } from '@lib/helpers';

import * as styles from './styles.module.scss';

const TextBubble = (props) => {
  const { children, className, size: sizeRaw, id } = props;
  const size = `size${capitalize(sizeRaw)}`;

  return (
    <div className={classNames(styles.layout, styles[size], className)} id={id}>
      {children}
    </div>
  );
};

export default TextBubble;
